import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d7dd7c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ion-padding-horizontal" }

import { OrdinaryClass } from "@/types";
import {
  EnrollmentCardElements,
  EnrollmentCourseProps,
  LearningArea,
  LearningSession,
  LearningContext,
  User,
  CustomElement,
  EventString,
  OrdinaryClassSummary,
  SubscriptionsManager,
  TmpList,
  AlertInformation,
  EnrollmentCourse,
} from "@/types";
import {
  executeLink,
  getCurrentElement,
  getCurrentLanguage,
  getCustomMessage,
  getLearningContexts,
  getNumberSequence,
  toSummary,
  getLearningAreasStructures,
  getContextAcronym,
  setupError,
} from "@/utils";
import {
  IonAlert,
  IonModal,
  IonGrid,
  IonRow,
  IonCol,
  IonHeader,
  IonToolbar,
  IonProgressBar,
  IonContent,
  IonTitle,
} from "@ionic/vue";
import { computed, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Store, useStore } from "vuex";

type AvailableModal =
  | "course_details"
  | "max_credits"
  | "max_courses"
  | "confirmation"
  | "wrong_subscription"
  | "unauthorized_operation"
  | "error";
//| "general_error"; //<!-- TODO (4): put general error with refresh button


export default /*#__PURE__*/_defineComponent({
  __name: 'CoursesSelectionList',
  async setup(__props) {

let __temp: any, __restore: any

const changeEnrollment = async () => {
  const requestArray = store.state.request.url.split("?"); //<!-- TODO (9): usare classe URL
  const pathArray = requestArray[0].split("/");
  const queryArray = requestArray[1].split("&");
  const course_id = queryArray[0].split("=")[1];
  const action = pathArray[pathArray.length - 1];
  const unscribe = action == "unsubscribe";
  const enrollment_availability =
    subscriptions_manager.checkEnrollmentAvailability(
      selected_context.value,
      selected_area.value,
      course_id
    );

  //let count;
  let tmp_card: EnrollmentCardElements;

  if (enrollment_availability.course != undefined) {
    /*count = 0;
    while ((available_courses = remaining_courses[learning_contexts[count].id][selected_area.value][tmp_course.group] - 1 >= 0) == true
      && ++count < learning_contexts.length);*/
    if (
      unscribe ||
      (enrollment_availability.available_courses &&
        enrollment_availability.available_credits)
    ) {
      await executeLink(
        undefined,
        (response: any) => {
          const pendingDate = new Date(response.data.data ?? "no date");
          const isPending = !isNaN(pendingDate.getTime());
          const enrollment_value = isPending ? pendingDate : !unscribe;

          let wasPending: boolean;

          if (enrollment_availability.course != undefined) {
            tmp_card = enrollment_availability.course as EnrollmentCardElements;
            wasPending = tmp_card.enrollment.isPending();
            if (!wasPending && !isPending) {
              if (store.state.static_subscription && !unscribe) {
                confirmation_data.title = (
                  tmp_card.content[1].content as EventString
                ).text;
                confirmation_data.message = getCurrentElement(
                  "course_confirmation"
                );
                confirmation_data.course = tmp_card;
                confirmation_data.unscribe = unscribe;
                confirmation_data.enrollment_value = enrollment_value;
                confirmation_data.update_credits = true;
                openConfirmation();
              } else {
                subscriptions_manager.updateCourseAndLinked(enrollment_value);
                subscriptions_manager.updateCredits(unscribe);
                trigger.value++;
              }
            } else if (store.state.static_subscription && isPending) {
              confirmation_data.title = (
                tmp_card.content[1].content as EventString
              ).text;
              confirmation_data.message = getCurrentElement("course_pending");
              confirmation_data.course = tmp_card;
              confirmation_data.enrollment_value = enrollment_value;
              confirmation_data.unscribe = unscribe;
              openConfirmation();
            } else {
              subscriptions_manager.updateCourseAndLinked(enrollment_value);
              trigger.value++;
            }
          } else {
            setAlertAndOpen("error");
          }
        },
        (error) => {
          if (error.response.status == 401) {
            setAlertAndOpen("unauthorized_operation");
          } else if (error.response.status == 409) {
            let message = "";
            if (error.response.data.specified_session) {
              message = getCurrentElement("student_already_subscribed");
            } else {
              message = getCurrentElement("student_course_already_attended");
            }
            setAlertAndOpen("error", message);
          } else {
            setAlertAndOpen("wrong_subscription");
          }
        }
      );
    } else {
      if (!enrollment_availability.available_courses) {
        return new Promise(() => setAlertAndOpen("max_courses"));
      } else if (!enrollment_availability.available_credits) {
        return new Promise(() => setAlertAndOpen("max_credits"));
      }
    }
  } else {
    setAlertAndOpen("error");
  }
};
const getCorrectName = (option: LearningArea) => {
  const language = getCurrentLanguage();

  const tmp_learning_area = learning_areas_structures.list.find(
    (a) => a.id == option.id
  );

  return tmp_learning_area != undefined
    ? tmp_learning_area[`${language}_title`]
    : "";
};
const setAlertAndOpen = (
  window: AvailableModal = store.state.event.event,
  message: string = store.state.event.data?.message
) => {
  switch (window) {
    case "max_credits":
      alert_information.title = getCurrentElement("error");
      alert_information.message = getCurrentElement("maximum_credits_error");
      break;
    case "max_courses":
      alert_information.title = getCurrentElement("error");
      alert_information.message = getCurrentElement("maximum_courses_error");
      break;
    case "wrong_subscription":
      alert_information.title = getCurrentElement("error");
      alert_information.message = getCurrentElement("wrong_subscription");
      break;
    case "unauthorized_operation":
      alert_information.title = getCurrentElement("error");
      alert_information.message = getCurrentElement("unauthorized_operation");
      break;
    case "error":
      setupError(message);
      break;
  }
  openAlert.value = true;
};
const closeModal = (window: AvailableModal) => {
  switch (window) {
    case "course_details":
      description_open.value = false;
      break;
    case "confirmation":
      confirmation_open.value = false;
      break;
    case "max_credits":
    case "max_courses":
      openAlert.value = false;
      break;
  }
};
const openDescription = () => {
  description.title = store.state.event.data.title;
  description.course_id = store.state.event.data.course_id;
  description.section = store.state.event.data.section;
  description_open.value = true;
};
const openConfirmation = () => {
  confirmation_open.value = true;
  timer_bar.value = 1;
  timer = setInterval(async () => {
    timer_bar.value -= 0.01;
    if (timer_bar.value <= 0) {
      await confirm(false, true);
    }
  }, 300);
};
const sendConfirmation = async () => {
  await confirm(store.state.event.data.outcome);
};
const confirm = async (outcome: boolean, time_expired = false) => {
  clearInterval(timer);
  try {
    await executeLink(
      "/v1/students/" +
        confirmation_data.student_id +
        "/confirmation?course_id=" +
        confirmation_data.course.id +
        "&session_id=" +
        confirmation_data.session_id +
        "&outcome=" +
        outcome,
      () => {
        if (!time_expired && outcome) {
          subscriptions_manager.updateCourseAndLinked(
            confirmation_data.enrollment_value
          );
          if (confirmation_data.update_credits) {
            subscriptions_manager.updateCredits(confirmation_data.unscribe);
          }
          trigger.value++;
        }
      },
      (error) => {
        if (error.response.status == 401) {
          setAlertAndOpen("unauthorized_operation");
        } else {
          setAlertAndOpen("wrong_subscription");
        }
      },
      "patch"
    );
  } catch (error) {
    setAlertAndOpen();
  }
  closeModal("confirmation");
};
const getBarColor = computed(() => {
  if (timer_bar.value > 0.5) {
    return "success";
  } else if (timer_bar.value > 0.25) {
    return "warning";
  } else {
    return "danger";
  }
});
const updateLearningAreaPlaceholder = (context_id: string) => {
  placeholder =
    learning_areas_structures.distribution[context_id].length > 0
      ? getCurrentElement("select") +
        (language == "italian" ? " l'" : " the ") +
        learning_area_sentence
      : getCurrentElement("no_learning_areas");
};

const store: Store<any> = useStore();
const $route = useRoute();
const $router = useRouter();
const language = getCurrentLanguage();
const user = User.getLoggedUser() as User;
const learning_session_id: string = $route.params.id as string;
const alert_information: AlertInformation = store.state.alert_information;
alert_information.buttons = [getCurrentElement("ok")];

const trigger = ref(0);
const learning_area_sentence = getCurrentElement("learning_area");
const openAlert = ref(false);
const selected_context = ref("");
const selected_area = ref("");
const description_open = ref(false);
const confirmation_open = ref(false);
const learning_sessions: LearningSession[] = (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
  "/v1/learning_sessions?year_of=" + learning_session_id,
  (response) => response.data.data.map((a: any) => new LearningSession(a)),
  () => []
))),
  __temp = await __temp,
  __restore(),
  __temp
);
const learning_session_position = learning_sessions.findIndex(
  (a) => a.id == parseInt(learning_session_id)
);
const learning_session =
  learning_session_position != -1
    ? learning_sessions[learning_session_position]
    : undefined;
const ordinary_class: OrdinaryClassSummary =
  learning_session != undefined
    ? (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
        "/v1/ordinary_classes?student_id=" +
          user.id +
          "&school_year=" +
          learning_session?.school_year,
        (response) =>
          response.data.data.map((a: any) =>
            new OrdinaryClass(a).toOrdinaryClassSummary()
          )[0]
      ))),
  __temp = await __temp,
  __restore(),
  __temp
)
    : undefined;

const description = {
  title: "",
  course_id: -1,
  section: "",
};
const confirmation_data: {
  title: string;
  message: string;
  student_id: number;
  course: EnrollmentCardElements;
  session_id: number | undefined;
  unscribe: boolean;
  enrollment_value: boolean | Date;
  update_credits: boolean;
} = {
  title: "",
  message: "",
  student_id: user.id,
  course: {} as EnrollmentCardElements,
  session_id: learning_session?.id,
  unscribe: false,
  enrollment_value: false,
  update_credits: false,
};
const buttons: CustomElement[] = [
  {
    id: "yes",
    type: "string",
    linkType: "event",
    content: {
      text: getCurrentElement("yes"),
      event: "yes",
      data: {
        outcome: true,
      },
    },
    colors: {
      background: {
        name: "success",
        type: "var",
      },
      text: {
        name: "white",
        type: "var",
      },
    },
    classes: {
      label: {
        "ion-padding": true,
        radius: true,
      },
    },
  },
  {
    id: "no",
    type: "string",
    linkType: "event",
    content: {
      text: getCurrentElement("no"),
      event: "no",
      data: {
        outcome: false,
      },
    },
    colors: {
      background: {
        name: "danger",
        type: "var",
      },
      text: {
        name: "white",
        type: "var",
      },
    },
    classes: {
      label: {
        "ion-padding": true,
        radius: true,
      },
    },
  },
];
const timer_bar = ref(1);
const subscriptions_manager = new SubscriptionsManager(); // Not ready, later there will be a loadParameters

let learning_areas_structures: {
  list: LearningArea[];
  distribution: TmpList<{ id: string }[]>;
};
let learning_contexts: LearningContext[] = [];
let tmp_courses: EnrollmentCourse[];
let timer: number;
let placeholder = getCurrentElement("no_learning_areas");

if (learning_session != undefined && ordinary_class != undefined) {
  learning_contexts = (
  ([__temp,__restore] = _withAsyncContext(() => getLearningContexts(user, learning_session_id))),
  __temp = await __temp,
  __restore(),
  __temp
);
  selected_context.value = learning_contexts[0].id;

  learning_areas_structures = (
  ([__temp,__restore] = _withAsyncContext(() => getLearningAreasStructures(
    learning_contexts,
    learning_session_id
  ))),
  __temp = await __temp,
  __restore(),
  __temp
);

  selected_area.value =
    learning_areas_structures.distribution[selected_context.value][0].id;

  if (
    learning_contexts.length > 0 &&
    learning_areas_structures.list.length > 0
  ) {
    tmp_courses = (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
      "/v2/courses?student_id=" +
        user.id +
        "&session_id=" +
        learning_session_id,
      (response) =>
        response.data.data.map(
          (a: EnrollmentCourseProps) => new EnrollmentCourse(a)
        ),
      () => []
    ))),
  __temp = await __temp,
  __restore(),
  __temp
);

    if (tmp_courses.length > 0) {
      (
  ([__temp,__restore] = _withAsyncContext(() => subscriptions_manager.loadParameters(
        user,
        ordinary_class,
        learning_contexts,
        learning_areas_structures.list,
        learning_sessions,
        tmp_courses,
        learning_session_id
      ))),
  await __temp,
  __restore()
);
      subscriptions_manager.showCourses(
        selected_context.value,
        selected_area.value
      );

      updateLearningAreaPlaceholder(selected_context.value);
      watch(selected_area, (new_area) => {
        subscriptions_manager.showCourses(selected_context.value, new_area);
        trigger.value++;
      });
    }
  }
  watch(selected_context, (new_context) => {
    updateLearningAreaPlaceholder(new_context);
    selected_area.value =
      learning_areas_structures.distribution[new_context].length > 0
        ? learning_areas_structures.distribution[new_context][0].id
        : "";
    if (tmp_courses.length > 0) {
      subscriptions_manager.showCourses(new_context, selected_area.value);
    }
    trigger.value++;
  });
} else {
  $router.push({ name: "learning_sessions" });
}

return (_ctx: any,_cache: any) => {
  const _component_course_description = _resolveComponent("course-description")!
  const _component_loading_component = _resolveComponent("loading-component")!
  const _component_ionic_element = _resolveComponent("ionic-element")!
  const _component_session_description = _resolveComponent("session-description")!
  const _component_custom_select = _resolveComponent("custom-select")!
  const _component_list_card = _resolveComponent("list-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonAlert), {
      "is-open": openAlert.value,
      header: _unref(alert_information).title,
      message: _unref(alert_information).message,
      buttons: _unref(alert_information).buttons,
      onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (closeModal('max_credits')))
    }, null, 8, ["is-open", "header", "message", "buttons"]),
    _createVNode(_unref(IonModal), {
      "is-open": description_open.value,
      onDidDismiss: _cache[2] || (_cache[2] = ($event: any) => (closeModal('course_details')))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            _createVNode(_component_course_description, {
              title: description.title,
              course_id: description.course_id,
              learning_session_id: _unref(learning_session_id),
              section: description.section,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (closeModal('course_details')))
            }, null, 8, ["title", "course_id", "learning_session_id", "section"])
          ]),
          fallback: _withCtx(() => [
            _createVNode(_component_loading_component)
          ]),
          _: 1
        }))
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_unref(IonModal), {
      "is-open": confirmation_open.value,
      "can-dismiss": () => !confirmation_open.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonHeader), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonToolbar), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonTitle), { class: "ion-text-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ionic_element, {
                      element: 
                _unref(getCustomMessage)(
                  'confirmation_title',
                  confirmation_data.title,
                  'title',
                  {
                    text: {
                      name: 'primary',
                      type: 'var',
                    },
                  }
                )
              
                    }, null, 8, ["element"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonProgressBar), {
                  value: timer_bar.value,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((timer_bar).value = $event)),
                  color: _unref(getBarColor)
                }, null, 8, ["value", "color"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonContent), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonGrid), { class: "ion-text-center" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonRow), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: 
                  _unref(getCustomMessage)(
                    'confirmation_message',
                    confirmation_data.message
                  )
                
                        }, null, 8, ["element"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonRow), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: 
                  _unref(getCustomMessage)(
                    'confirmation_warning',
                    _unref(getCurrentElement)('confrimation_warning'),
                    'string',
                    {
                      text: {
                        name: 'warning',
                        type: 'var',
                      },
                    }
                  )
                
                        }, null, 8, ["element"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonRow), null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getNumberSequence)(2), (i) => {
                      return (_openBlock(), _createBlock(_unref(IonCol), {
                        key: buttons[i].id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ionic_element, {
                            element: buttons[i],
                            onSignal_event: _cache[4] || (_cache[4] = ($event: any) => (sendConfirmation()))
                          }, null, 8, ["element"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open", "can-dismiss"]),
    (_unref($route).params.id != undefined)
      ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_component_session_description, {
              key: trigger.value,
              id: _unref($route).params.id,
              learning_context: 
            _unref(toSummary)(_unref(learning_contexts).find((a) => a.id == selected_context.value))
          
            }, null, 8, ["id", "learning_context"]))
          ]),
          fallback: _withCtx(() => [
            _createVNode(_component_loading_component)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(IonGrid), { class: "ion-no-padding" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonRow), { class: "ion-no-padding" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), {
              size: "auto",
              class: "ion-no-padding"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_custom_select, {
                  selected_option: selected_context.value,
                  "onUpdate:selected_option": _cache[5] || (_cache[5] = ($event: any) => ((selected_context).value = $event)),
                  list: _unref(learning_contexts),
                  label: _unref(getCurrentElement)('learning_context') + ':',
                  aria_label: _unref(getCurrentElement)('learning_context'),
                  placeholder: _unref(getCurrentElement)('learning_context_choice'),
                  getCompleteName: _unref(getContextAcronym)
                }, null, 8, ["selected_option", "list", "label", "aria_label", "placeholder", "getCompleteName"])
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCol), {
              size: "auto",
              class: "ion-no-padding"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_custom_select, {
                  selected_option: selected_area.value,
                  "onUpdate:selected_option": _cache[6] || (_cache[6] = ($event: any) => ((selected_area).value = $event)),
                  list: _unref(learning_areas_structures).distribution[selected_context.value],
                  label: _unref(learning_area_sentence) + ':',
                  aria_label: _unref(learning_area_sentence),
                  placeholder: _unref(placeholder),
                  getCompleteName: getCorrectName
                }, null, 8, ["selected_option", "list", "label", "aria_label", "placeholder"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_component_list_card, {
      key: trigger.value,
      onExecute_link: _cache[7] || (_cache[7] = ($event: any) => (changeEnrollment())),
      onSignal_event: _cache[8] || (_cache[8] = ($event: any) => (openDescription())),
      emptiness_message: 
        _unref(getCustomMessage)(
          'emptiness_message',
          _unref(getCurrentElement)('no_proposed_courses')
        )
      ,
      cards_list: _unref(subscriptions_manager).courses,
      "onUpdate:cards_list": _cache[9] || (_cache[9] = ($event: any) => ((_unref(subscriptions_manager).courses) = $event)),
      colors: {
        list_borders: {
          name: 'black',
          type: 'var',
          alpha: 0.25,
        },
        text: {
          name: 'primary',
          type: 'var',
        },
      }
    }, null, 8, ["emptiness_message", "cards_list", "colors"]))
  ]))
}
}

})